import React from "react";
import Drawer, { DrawerContent, DrawerHeader } from "@material/react-drawer";
import List, {
  ListItem,
  ListItemGraphic,
  ListItemText
} from "@material/react-list";
import MaterialIcon from "@material/react-material-icon";
import CV from "./CV";
import Github from "react-ionicons/lib/LogoGithub";
import LinkedIn from "react-ionicons/lib/LogoLinkedin";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

class MyDrawer extends React.Component {
  static propTypes = {
    drawerOpen: PropTypes.bool.isRequired,
    closeDrawer: PropTypes.func.isRequired
  };

  goHome = () => {
    const { history, closeDrawer } = this.props;
    closeDrawer();
    history.push("/");
  };

  goToContact = () => {
    const { history, closeDrawer } = this.props;
    closeDrawer();
    history.push("/contact");
  };

  goToCredits = () => {
    const { history, closeDrawer } = this.props;
    closeDrawer();
    history.push("/credits");
  };

  render() {
    const { drawerOpen, closeDrawer, history } = this.props;

    const menuItems = ["/", "/contact", "", "", "", "/credits"];

    return (
      <Drawer modal open={drawerOpen} onClose={closeDrawer}>
        <DrawerHeader />
        <DrawerContent>
          <List
            singleSelection
            selectedIndex={menuItems.indexOf(history.location.pathname)}
          >
            <ListItem onClick={this.goHome}>
              <ListItemGraphic graphic={<MaterialIcon icon="home" />} />
              <ListItemText primaryText="Home" />
            </ListItem>
            <ListItem onClick={this.goToContact}>
              <ListItemGraphic graphic={<MaterialIcon icon="mail" />} />
              <ListItemText primaryText="Contact me" />
            </ListItem>
            <ListItem
              tag="a"
              href={require(`../assets/cv/${process.env.REACT_APP_RESUME_PATH}`)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ListItemGraphic graphic={<CV />} />
              <ListItemText primaryText="Checkout my resume" />
            </ListItem>
            <ListItem
              tag="a"
              href="https://github.com/Moccko/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ListItemGraphic graphic={<Github />} />
              <ListItemText primaryText="Have a look to my GitHub" />
            </ListItem>
            <ListItem
              tag="a"
              href="https://www.linkedin.com/in/roman-rieunier/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ListItemGraphic graphic={<LinkedIn />} />
              <ListItemText primaryText="Let's connect on LinkedIn" />
            </ListItem>
            <ListItem onClick={this.goToCredits}>
              <ListItemGraphic graphic={<MaterialIcon icon="thumb_up" />} />
              <ListItemText primaryText="Credits" />
            </ListItem>
          </List>
        </DrawerContent>
      </Drawer>
    );
  }
}

export default withRouter(MyDrawer);
